import cn from 'classnames';
import { Anchor } from '../../../../shared/Anchor';
import s from './BuyExperiences.module.scss';

const imageMap = {
  AUTOGRAPH: '/images/guests/autographs-stripe@2x.png',
  PHOTO_OP: '/images/guests/photo-ops-stripe@2x.png',
  LEARN_MORE: '/images/guests/learn-more-stripe@2x.png',
};

const headingMap = {
  AUTOGRAPH: 'Autographs',
  PHOTO_OP: 'Photo Ops',
  LEARN_MORE: 'Special experiences',
};

export function getHeading(experiences) {
  const [a, b, c] = experiences;
  const phrases = [
    headingMap[a?.type],
    headingMap[b?.type],
    headingMap[c?.type],
  ].filter(Boolean);

  if (phrases.length === 3) {
    return `${phrases[0]}, ${phrases[1]}, and ${phrases[2]}`;
  }

  return phrases.join(' and ');
}

export default function BuyExperiences({ experiences }) {
  return (
    <div className={s.wrapper}>
      <div className="container">
        <div className="row">
          <div className="col-xs-12">
            <div className={s.heading}>{getHeading(experiences)}</div>
            <div className={s.body}>
              <div className="row">
                {experiences.map((experience, index) => (
                  <div key={index} className="col-xs-12 col-sm-4">
                    <div className={s.card}>
                      <Anchor
                        to={experience.link}
                        className={cn({
                          'embed-responsive embed-responsive-16by10': true,
                          [s.image]: true,
                          [s.stripeImage]: !experience.image,
                        })}
                      >
                        <img
                          src={experience.image ?? imageMap[experience.type]}
                          alt=""
                          className="embed-responsive-item"
                        />
                      </Anchor>
                      <Anchor to={experience.link} className={s.button}>
                        Buy Now
                      </Anchor>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
